import { Link, useRouter } from "expo-router";
import { StyleSheet, View } from "react-native";
import { Button, Card, Screen, Text } from "~/components/ui";
import { spacing } from "~/styles/tokens";

export default function NotFoundScreen() {
  const router = useRouter();
  return (
    <Screen width="narrow">
      <View style={styles.center}>
        <Card padding="lg">
          <Text variant="heading" align="center">
            Nothing here
          </Text>
          <Text variant="body" align="center" style={{ marginTop: spacing.sm }}>
            That screen doesn&apos;t exist in DoughBro.
          </Text>
          <Link href="/" asChild>
            <View>
              <Button
                label="Back home"
                onPress={() => router.replace("/")}
                style={{ marginTop: spacing.md }}
              />
            </View>
          </Link>
        </Card>
      </View>
    </Screen>
  );
}

const styles = StyleSheet.create({
  center: {
    flex: 1,
    justifyContent: "center",
  },
});
